// 스크립트 로딩 캐시
const loadedScripts = new Set();

export function loadScript(src) {
  return new Promise((resolve, reject) => {
    // 이미 로드된 스크립트라면 즉시 resolve
    if (loadedScripts.has(src)) {
      resolve();
      return;
    }

    // 이미 DOM에 있는 스크립트 태그 확인
    if (document.querySelector(`script[src="${src}"]`)) {
      loadedScripts.add(src);
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    
    script.onload = () => {
      loadedScripts.add(src);
      resolve();
    };
    
    script.onerror = (error) => {
      reject(new Error(`Failed to load script: ${src}`));
    };
    
    document.head.appendChild(script);
  });
}

export function loadScripts(sources) {
  return Promise.all(sources.map(src => loadScript(src)));
}